import { FC } from "react";
import { useTranslation } from "react-i18next";

type Props = {
  percentage: number;
};

export const ChapterStatusBadge: FC<Props> = ({ percentage }) => {
  const { t } = useTranslation();

  const status =
    percentage === 0
      ? t("dashboard.chapterStatus.notStarted")
      : percentage === 100
      ? t("dashboard.chapterStatus.completed")
      : t("dashboard.chapterStatus.inProgress");

  const color =
    percentage === 0 ? "delicate" : percentage === 100 ? "herb" : "sand";

  const colorVariants = {
    delicate: "bg-delicate-10 text-delicate-700",
    herb: "bg-herb-10 text-herb-700",
    sand: "bg-sand-10 text-sand-700",
  };

  return (
    <span
      className={[
        "px-2 inline-flex text-xs leading-5 font-semibold rounded-full",
        colorVariants[color],
      ].join(" ")}
    >
      {status}
    </span>
  );
};
